import { currencyNumberFormat } from "../helpers/constant";
export default {
  data() {
    return {};
  },
  computed: {},
  methods: {
    createDropDownElement(label, key, options, cols, callBackMethod) {
      return {
        type: "Dropdown",
        label: label,
        key: key,
        options: options,
        class: "",
        cols: cols,
        isdisabled: false,
        callBackMethod: callBackMethod,
      };
    },
    createInputElement(
      label,
      key,
      cols,
      isAllowOnlyNumber,
      currencyFormat,
      appendText,
      isdisabled,
      isEditiable,
      AllowOnlyDecimalTill,
      length,
      max,
      callBackMethod
    ) {
      return {
        type: "Input",
        label: label,
        currencyFormat: currencyFormat,
        appendText: appendText,
        key: key,
        isAllowOnlyNumber: isAllowOnlyNumber,
        class: "",
        cols: cols,
        isdisabled: isdisabled,
        isEditiable: isEditiable,
        AllowOnlyDecimalTill: AllowOnlyDecimalTill,
        length: length,
        max: max,
        callBackMethod: callBackMethod,
      };
    },
    createEditButtonElement() {
      return {
        type: "EditButton",
        label: "Edit",
        variation: "flat",
        key: "edit",
        icon: "pencil",
        class: "flexiblePosition",
        cols: 4,
        isdisabled: false,
        align: "center",
        callBackMethod: "editBaseLineButton_Click",
      };
    },
    createButtonElement(label, variation, key, cols, callBackMethod) {
      return {
        type: "Button",
        label: label,
        variation: variation,
        key: key,
        class: "shrink",
        cols: cols,
        isdisabled: false,
        callBackMethod: callBackMethod,
      };
    },

    DefaultReadOnlyPerElement(label, key, col) {
      return this.createInputElement(
        label,
        key,
        col,
        false,
        "",
        "%",
        true,
        true
      );
    },
    DefaultReadOnlyPerCurrency(label, key, col) {
      return this.createInputElement(
        label,
        key,
        col,
        false,
        "$",
        "",
        true,
        true
      );
    },
    DefaultReadOnlyCurrencyElement(label, key, col) {
      return this.createInputElement(
        label,
        key,
        col,
        false,
        "",
        "",
        true,
        true
      );
    },
    DefaultReadOnlyElement(label, key, col) {
      return this.createInputElement(
        label,
        key,
        col,
        false,
        "",
        "",
        true,
        true
      );
    },

    DefaultEditablePerElement(
      label,
      key,
      col,
      max,
      callBackMethod,
      length = 6
    ) {
      return this.createInputElement(
        label,
        key,
        col,
        true,
        "",
        "%",
        false,
        false,
        2,
        length,
        max,
        callBackMethod
      );
    },
    DefaultEditableCurrencyElement(
      label,
      key,
      col,
      max,
      callBackMethod,
      length = 6
    ) {
      return this.createInputElement(
        label,
        key,
        col,
        true,
        currencyNumberFormat,
        "",
        false,
        false,
        0,
        length,
        max,
        callBackMethod
      );
    },
  },
};
